<div class="payment-sip-form-wrapper" [ngClass]="config?.formTheme">

  <app-offer-tag *ngIf="config?.showOfferTag"></app-offer-tag>

  <div *ngIf="config?.title" class="payment-sip-form-header">
    <div class="title">{{config?.title}}</div>
    <div class="sub-title" [innerHTML]="config?.subtile"></div>
  </div>

  <div *ngIf="config?.formImg" class="payment-sip-form-img">
    <img [attr.data-src]="config?.formImg">
  </div>

  <div *ngIf="config?.childCount" class="payment-sip-form-child-count">
    Your contribution of <strong>{{util.formatAmount(config?.amount, config?.currency)}}</strong>
    {{config?.frequency_term ? ' / ' + config?.frequency + ' days' : ' monthly'}} will support upto <strong>{{lives_count}} lives</strong> in a year
  </div>

  <div *ngIf="!config?.enable_person_based_amount && config?.showSlabs" class="payment-sip-form-slabs">
    <app-payment-sip-slabs *ngIf="config?.paymentDetails?.min_donation" [config]="config" (setCurrency)="setCurrency.emit($event)" (amountEmit)="emitConfig($event)"></app-payment-sip-slabs>
  </div>

  <div *ngIf="config?.showExtraInfo" class="extra-info">
    <app-module-loader moduleId="sip-info" selector="app-sip-info" [load]="config?.showExtraInfo"
      [inputs]="{config: {curency: config?.currency}}">
    </app-module-loader>
  </div>

  <div *ngIf="config?.enable_multicause_slection && config?.currency==='INR'" class="multi-cause-selection">
    <app-multi-cause-sip-selection [config]="config"></app-multi-cause-sip-selection>
  </div>

  <div *ngIf="config?.enable_person_based_amount && config?.currency && config?.amount" class="person">
    <app-module-loader moduleId="select-live" selector="app-select-live" [load]="true" [inputs]="{config: config}">
    </app-module-loader>
  </div>

  <div *ngIf="config?.frequency_term" class="payment-sip-form-slabs">
    <div class="donation-frequency">Choose how often you wish to contribute</div>
    <app-pledge-frequency-slab [config]="config?.frequency_slabs" (selectionEmit)="setFrequency($event)"></app-pledge-frequency-slab>
  </div>

  <form [hidden]="config?.user && config?.user?.extension && config?.user?.phone_1 && !vars.isDummyEmail" [formGroup]="donationForm" (ngSubmit)="submitPayment()">
    <app-input inputType="text" [control]="nameControl" [group]="donationForm" [placeHolder]="info.name.placeholder" icon="icon-user" [errorMessage]="info.name.error"></app-input>
    <app-input *ngIf="!vars.isAgent || !userData?.email" inputType="email" [control]="emailControl" [group]="donationForm" [placeHolder]="info.email.placeholder" icon="icon-mail" [errorMessage]="info.email.error" (onFocusOut)="onFocusOut('email')"></app-input>
    <app-phone-number-input-v2
      *ngIf="!vars.isAgent || !userData?.phone_1"
      inputId="mobileInput"
      theme="material"
      [group]="donationForm"
      [control]="mobileControl"
      (onCountryChange)="setCountry($event)"
      (onFocus)="!$event ? onFocusOut('phone') : undefined"
    />
    <!-- <app-intl-input [control]="donationForm.get('mobile')" [group]="donationForm" (numberEmit)="phoneNumber=$event"></app-intl-input> -->
  </form>

  <div *ngIf="config?.lastOrder?.payment_gateway?.match('stripe') && !config?.lastOrder?.payment_mode?.match('LINK') && config?.lastOrder?.iso_currency!=='INR' && config?.currency!=='INR'" class="payment-sip-form-last-order">
    Pay Using Card: <strong>XXXX {{config?.lastOrder?.payment_details?.last4}}</strong> ({{config?.user?.full_name}})
  </div>

  <div class="payment-sip-form-donate-btn">
    <app-payment-sip-button [config]="config" (btnClick)="submitPayment()"></app-payment-sip-button>
  </div>

  <div *ngIf="!config?.hideSipDonors" class="payment-sip-form-donate-donors">
    <app-payment-sip-donors></app-payment-sip-donors>
  </div>

  <div *ngIf="config?.showVerifiedBy" class="verified-by">
    <div class="image"><img loading="lazy" data-src="/assets/images/verified-by.png" /></div>
    <div class="text">By continuing I accept the <a href="https://customerhappiness.ketto.org/portal/en/kb/articles/terms-of-use-7-8-2021-1" target="_blank"><strong>Terms and Conditions</strong></a> & <a href="https://customerhappiness.ketto.org/portal/en/kb/articles/privacy-policy-7-8-2021" target="_blank"><strong>Privacy Policy</strong></a></div>
  </div>

  <div *ngIf="config?.formNote" class="payment-sip-form-note">
    You can cancel your subscription anytime by visiting the profile section or by contacting us at <a href="mailto:info@ketto.org">info@ketto.org</a>
  </div>

  <div *ngIf="!config?.hideCaptchaNote" class="capthca-note">
    This site is protected by reCAPTCHA and the Google
    <a href="https://policies.google.com/privacy" target="_blank">Privacy Policy</a> and
    <a href="https://policies.google.com/terms" target="_blank">Terms of Service</a> apply.
  </div>

</div>

<!-- One tap otp confrimation -->
<div *ngIf="oneTapOtpPopup" class="onetap">
  <app-module-loader moduleId="otp-confirmation" selector="app-otp-confirmation"
                    [load]="true"
                    [outputs]="{ verified: otpVerified }">
  </app-module-loader>
</div>

<!-- Captcha -->
<app-g-captcha (dataEmit)="captchaResponse($event)"></app-g-captcha>